import React from 'react';
import {ContainerBoxClassList, InsideBox, P} from '../Style/ClassList.style';
import classEmptyIcon from '../../../images/class_list_empty.png';
import {_SYSTEM_TITLES} from '../../../configuration/SystemTitles/SystemTitles.config';


const ClassListEmpty = ({inputerror}) => (
    <ContainerBoxClassList inputerror={inputerror}>
        <InsideBox>
            <img
                id='class_empty'
                src={classEmptyIcon}
                srcSet={classEmptyIcon}
                alt='class_empty'
                style={{ width: '78.18px', height: 'auto' }}
            />
            <P>{_SYSTEM_TITLES.classListEmptyTitle}</P>
        </InsideBox>
    </ContainerBoxClassList>

);

export default ClassListEmpty;
